export default __webpack_public_path__ + "media/SubhashChandraShow.aca31422.svg";